import {
  map,
  lensPath,
  set,
  values,
  omit,
  flatten,
  toUpper,
  compose,
  pathOr,
  uniqBy,
  equals
} from 'ramda';
import {
  SMARTMATCH_TYPE_ADMIN_ISO,
  SMARTMATCH_TYPE_HIGH_CREST,
  SMARTMATCH_TYPE_ISO,
} from 'src/services/constants';
import { getNamespaceName } from 'src/services/objects/namespaces';
import { groupByWith } from 'src/utilities/groupBy';
import { getFullName } from 'src/utilities/naming';

const namespaceName = getNamespaceName();


export const buildAssigneeGroupForReAssign = (advisorProfiles: any, searchKey: string) => {
  const g = equals(searchKey, 'name') ? groupedAdvisorsWithNameValue(advisorProfiles) :
    groupedAdvisors(advisorProfiles);
  const _gOmitForReassign = _gSelf(
    [
      SMARTMATCH_TYPE_ISO,
      SMARTMATCH_TYPE_ADMIN_ISO,
      SMARTMATCH_TYPE_HIGH_CREST,
    ],
    g
  );

  return uniqBy((item) => item.id, _gOmitForReassign);
};

export const buildAssigneeGroupForHighCrest = (advisorProfiles: any) => {
  const g = groupedAdvisorsWithNameValue(advisorProfiles);
  const _gForHighcrest = _nSelf('high crest', SMARTMATCH_TYPE_HIGH_CREST, g);
  return uniqBy((item) => item.id, _gForHighcrest);
};

const _gSelf = (selfName: string[], g: any) =>
  map(
    (advisor: any) => groupTitle(advisor, toUpper(namespaceName)),
    flatten(values(omit(selfName, g)))
  );

const _nSelf = (advisorName: string, selfName: string, g: any) =>
  map(
    (advisor: any) => groupTitle(advisor, toUpper(advisorName)),
    g[selfName] || []
  );

const groupedAdvisors = (advisorProfiles: any) =>
  groupByWith(['persona'])(mkAdvisorSelectorsWithEmailValue(advisorProfiles));

const groupedAdvisorsWithNameValue = (advisorProfiles: any) =>
  groupByWith(['persona'])(mkAdvisorSelectorsWithNameValue(advisorProfiles));

const groupTitle = (advisor: any, title: any) =>
  set(lensPath(['title']), title, advisor);

const mkAdvisorSelectorsWithEmailValue = (advisorProfiles: any) =>
  map((advisorProfile: any) => {
    return compose(
      set(lensPath(['label']), getFullName(advisorProfile)),
      set(lensPath(['value']), pathOr('', ['email'], advisorProfile)),
      set(lensPath(['parent']), 'Internal team')
    )(advisorProfile);
  }, advisorProfiles || []);

const mkAdvisorSelectorsWithNameValue = (advisorProfiles: any) =>
  map((advisorProfile: any) => {
    return compose(
      set(lensPath(['label']), getFullName(advisorProfile)),
      set(lensPath(['value']), getFullName(advisorProfile)),
      set(lensPath(['parent']), 'Internal team')
    )(advisorProfile);
  }, advisorProfiles || []);

/// Return the configured sales email only. The site sales can be configured in
// SALES_PROFILE
/*const _gSiteSales = () => {
  const s = flatten([
    map(
      (advisor: any) => groupTitle(advisor, toUpper(USER_ONBOARD_SALES)),
      groppedAdvisors[USER_ONBOARD_SALES] || []
    ),
    [],
  ]);
  return filter((e: any) => {
    return equals(pathOr('', ['first_name'], e), SALES_PROFILE_NAME);
  }, s);
};*/
